import axios from 'axios';

let userStoreData;

function getData() {
  if (_.isEmpty(userStoreData)) {
    const dataEl = document.querySelector('#user-store-data');
    userStoreData = dataEl ? JSON.parse(dataEl.getAttribute('data')) : {};
  }
  return userStoreData;
}

export const userData = {
  getFeatures() {
    return getData().features || {};
  },

  getUser() {
    return getData().user || {};
  },

  getSession() {
    return axios.get('/users/current_session').then(response => response.data);
  },

  hasAccount() {
    return this.getUser().hasAccount;
  },

  missingBillingAddress() {
    return this.getUser().missingBillingAddress;
  },

  isFullUser() {
    return !!this.getUser().isFullUser;
  },

  isLoggedIn() {
    return !!this.getUser().userId;
  },

  isCanadian() {
    const countryCode = this.getUser().countryCode;
    return countryCode && countryCode === 'CA';
  },

  isUs() {
    const countryCode = this.getUser().countryCode;
    return countryCode && countryCode === 'US';
  },
};
